import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import {EmbedService} from "./services/embed.service";
import {TrackingService} from "./services/tracking.service";

/**
 * The basic app component for running an advisor. Every advisor has its own module which is lazyloaded.
 */
@Component({
  template: ``
})
export abstract  class AdvisorComponent implements OnInit{

  static readonly SCREEN_WIDTH_MEDIUM = 640;

  /**
   * Some css classes for the advisor container.
   */
  advisorClasses: string;

  /**
   * Toogle if the advisor is embeded or not.
   */
  embedded: boolean = false;

  /**
   * Constructor. Initialize all needed basic functions
   * @param translate
   * @param router
   * @param embedService
   * @param trackingService
   */
  protected constructor(public translate: TranslateService, protected router: Router, protected embedService: EmbedService, protected trackingService: TrackingService) {
    // initialize the translator
    translate.addLangs(['de']);
    translate.setDefaultLang('de');
    translate.use('de');

    // handle some router events
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      // after a route is called, we set the parts of the route as css classes on the advisor container
      this.advisorClasses = this.router.url.replace(/#.+$/, "").replace(/\?.+$/, "").replace(/\//g, " ").trim();
    });
  }

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.trackingService.init();
    this.embedService.init();
    this.embedded = this.embedService.isEmbedded();
  }

}
